import * as tinycolor from 'tinycolor2'

const cachedColours = {}

export function getReadableBackgoundColourCached (hex) {
  if (!(hex in cachedColours)) {
    cachedColours[hex] = tinycolor.mostReadable(hex, ['#000', '#fff']).toHexString()
  }
  return cachedColours[hex]
}
